import {Mutation, gql} from 'apollo-angular';
import { Injectable } from '@angular/core';


import { registration, registrationVariables } from './types/registration';

@Injectable({ providedIn: 'root' })
export class RewardsSignupGQL extends Mutation<registration, registrationVariables> {
  document = gql`
    mutation registration(
      $email: String
      $password_confirmation: String
      $last_name: String
      $password: String
      $first_name: String
    ) {
      registration(
        registration: {
          email: $email
          first_name: $first_name
          last_name: $last_name
          password: $password
          password_confirmation: $password_confirmation
        }
      ) {
        success
      }
    }
  `;
}
